<div class="border-bottom pb-4 pt-4 mb-2">
  <div class="d-flex align-items-center mb-2">
    <tr-icon [icon]="icon.square" [size]="size.extraLarge" classes="mr-3"></tr-icon>
    <h2 class="m-0">Connect With Square</h2>
  </div>
  <div class="w-100 pl-5">
    <div *ngIf="isSquared; else isNotSquared">
      <p>This app is now connected to your Square account.</p>
      <div>
        <div class="lead lead-small pt-3 pb-2">Do you want to:</div>
        <ul class="form-check list-unstyled">
          <li class="ml-3">
            <label class="form-check-label">
              <input
                type="checkbox"
                class="form-check-input"
                [disabled]="disabled"
                [(ngModel)]="squareOptions.squareSyncOrders"
                (ngModelChange)="syncOrdersChanged($event)"
              >Sync orders from Square Online and POS to Tablesready
            </label>
          </li>
          <li *ngIf="account.features.squareCustomer" class="ml-3">
            <label class="form-check-label">
              <input
                type="checkbox"
                class="form-check-input"
                [disabled]="disabled"
                [(ngModel)]="squareOptions.squareSyncCustomers"
                (ngModelChange)="syncCustomersChanged($event)"
              >Sync parties from Tablesready to your Square Customers database
            </label>
          </li>
        </ul>
      </div>

      <div *ngIf="account.features.squareCustomer && squareOptions.squareSyncCustomers">
        <p><b>Customers added to Tablesready will be created in your Square customers database.</b></p>
        <button
          class="btn btn-success m-1"
          (click)="updateSquareOptions()"
          [disabled]="disabled"
          angularticsCategory="settings"
          angulartics2On="click"
          angularticsAction="Square Customers Sync"
        >Save</button>
      </div>

      <div *ngIf="squareOptions.squareSyncOrders">
        <form role="form" name="squareLocationsSubscribe" #squareLocationsSubscribe="ngForm" *ngIf="squareLocations" novalidate>
          <div>
            <div class="lead lead-small pt-3 pb-2">Choose the locations to sync transactions from:</div>
            <ul class="form-check list-unstyled" *ngFor="let location of squareLocations">
              <li class="ml-3">
                <label class="form-check-label">
                  <input
                    type="checkbox"
                    name="square-location-{{location.id}}"
                    class="form-check-input"
                    [disabled]="disabled"
                    [(ngModel)]="location.selected"
                    [ngModelOptions]="{standalone: false}"
                  >{{ location.name }}
                </label>
              </li>
            </ul>
          </div>
          <div class="form-group">
            <div class="d-flex flex-wrap justify-content-start">
              <button
                class="btn btn-success m-1"
                (click)="subscribeLocations()"
                [disabled]="squareLocationsSubscribe.invalid || squareLocationsSubscribe.pristine"
                angularticsCategory="settings"
                angulartics2On="click"
                angularticsAction="Square Locations Subscribe"
              >Save</button>
              <button
                class="btn btn-info m-1"
                (click)="updateLocations()"
                angularticsCategory="settings"
                angulartics2On="click"
                angularticsAction="Square Locations Update"
              >Refresh Locations List</button>
            </div>
          </div>
        </form>

        <div *ngIf="squareLocationsSubscriptions.length">
          <p class="lead lead-small">Here's how it works:</p>
          <ul>
            <li>Create a transaction in Square from the location(s) you selected above</li>
            <li>Add a customer to the transaction at any point</li>
            <li>Choose an existing customer or create a new one by entering their name and phone number</li>
            <li>Alternatively, you can enter a name &amp; phone number as the order ticket</li>
            <li>That's it. A few seconds after you complete the transaction, the order should automatically appear on your waitlist!</li>
          </ul>
        </div>

        <form name="squareOptionsForm" role="form" #squareOptionsForm="ngForm" *ngIf="squareLocationsSubscriptions.length" class="mt-3">
          <p class="lead">Additional Square Options</p>
          <div class="mb-3">
            <ul class="form-check list-unstyled">
              <li class="ml-3">
                <label class="form-check-label">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    name="parseOrderTicket"
                    [disabled]="disabled"
                    [(ngModel)]="squareOptions.parseOrderTicket"
                    [ngModelOptions]="{standalone: false}"
                  > Get name &amp; phone number by parsing Order Ticket
                </label>
              </li>
              <li class="ml-3">
                <label class="form-check-label">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    name="hideNoPhone"
                    [disabled]="disabled"
                    [(ngModel)]="squareOptions.hideNoPhone"
                    [ngModelOptions]="{standalone: false}"
                  > Hide transactions with no phone number
                </label>
              </li>
              <li class="ml-3">
                <label class="form-check-label">
                  <input
                    type="checkbox"
                    name="hideReceiptNum"
                    class="form-check-input"
                    [disabled]="disabled"
                    [(ngModel)]="squareOptions.hideReceiptNum"
                    [ngModelOptions]="{standalone: false}"
                  > Hide Square Receipt # once customer information has been received
                </label>
              </li>
              <li class="ml-3">
                <label class="form-check-label">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    name="showOrderItems"
                    [disabled]="disabled"
                    [(ngModel)]="squareOptions.showOrderItems"
                    [ngModelOptions]="{standalone: false}"
                  > Display order items with modifiers in Notes field
                </label>
              </li>
              <li class="ml-3">
                <div class="d-flex flex-column categories">
                  <label>
                    <span class="d-flex flex-row align-items-center">
                    <input
                      type="checkbox"
                      name="filterCategories"
                      class="form-check-input"
                      [disabled]="disabled"
                      [(ngModel)]="squareOptions.filterCategories"
                    > Only show transactions and order items from these categories:
                  </span>
                  </label>
                  <frontend-dropdown-plain
                    class="mb-2 form-filter-categories"
                    name="filterCategoryOptions"
                    [disabled]="disabled"
                    [items]="squareCategories"
                    [addTag]="true"
                    [multiple]="true"
                    [(ngModel)]="squareOptions.filterCategoryOptions"
                    placeholder="Category"
                  ></frontend-dropdown-plain>
                </div>
              </li>
              <li class="ml-3">
                <label class="form-check-label">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    name="sendReadyOnCompleted"
                    [disabled]="disabled"
                    [(ngModel)]="squareOptions.sendReadyOnCompleted"
                    [ngModelOptions]="{standalone: false}"
                  > Send "ready" SMS and mark party as served when order marked as completed in Square
                </label>
              </li>
            </ul>
          </div>

          <ng-container *ngIf="account.features.togo">
          <p>Page to display Square orders on</p>
          <div class="mb-3">
            <ul class="form-check list-unstyled">
              <li class="ml-3">
                <div class="d-flex flex-column categories">
                  <frontend-dropdown
                    class="form-filter-categories"
                    elementId="display-page"
                    bindLabel="label"
                    bindValue="value"
                    [(ngModel)]="squareOptions.displayOrdersPage"
                    [items]="displayOrdersPageOptions"
                    [ngModelOptions]="{standalone: false}"
                    [allowDisablingOptions]="true"
                  ></frontend-dropdown>
                </div>
              </li>
            </ul>
          </div>
          </ng-container>

          <div class="form-group">
            <button
              class="btn btn-success"
              (click)="updateSquareOptions()"
              [disabled]="squareOptionsForm.invalid || squareOptionsForm.pristine || disabled"
              angularticsCategory="settings"
              angulartics2On="click"
              angularticsAction="Square Options Update">Save
            </button>
          </div>
        </form>
    </div>
    <div>
      <button
        class="btn btn-danger mb-3 "
        [disabled]="disabled"
        (click)="disconnectSquare()"
        angularticsCategory="settings"
        angulartics2On="click"
        angularticsAction="Square Disconnect"
      >Disconnect Square</button>
    </div>
  </div>
  <ng-template #isNotSquared>
    <p>
      Connect this application to your Square account and allow it to read your
      payment data so it can automatically populate your customers' names and
      phone numbers when new transactions are completed.
    </p>
    <button
      class="btn btn-info mb-1"
      angularticsCategory="settings"
      angulartics2On="click"
      angularticsAction="Square Connect"
      [disabled]="disabled"
      (click)="authorize()"
    >Authorize</button>
    </ng-template>
  </div>
</div>
